/**
 * Monta o body de POST /team-spaces/dm a partir da opção escolhida no picker.
 * Tolera perda do campo `kind` do MUI Autocomplete re-resolvendo pela lista.
 */
export function buildTeamDmPayload(target, targets = []) {
  if (!target) return null;

  let option = target;
  if (typeof target === "string") {
    option = targets.find((t) => t.label === target) || null;
  }
  if (!option) return null;

  let { kind, id, label } = option;
  if (!kind || id == null) {
    const resolved =
      targets.find((t) => String(t.id) === String(id) && (!kind || t.kind === kind)) ||
      targets.find((t) => t.label === label && (!kind || t.kind === kind)) ||
      targets.find((t) => t.label === label);
    if (resolved) {
      kind = resolved.kind;
      id = resolved.id;
    }
  }

  if (id == null || id === "") return null;

  if (kind === "agent") {
    return { agentId: String(id).trim() };
  }
  if (kind === "chatbot") {
    const chatbotId = Number(id);
    return Number.isFinite(chatbotId) && chatbotId > 0 ? { chatbotId } : null;
  }
  if (kind === "user") {
    const userId = Number(id);
    return Number.isFinite(userId) && userId > 0 ? { userId } : null;
  }

  // Fallback: UUID → agente; numérico → usuário ou chatbot
  const asString = String(id).trim();
  if (/^[0-9a-f-]{36}$/i.test(asString)) {
    return { agentId: asString };
  }
  const numericId = Number(id);
  if (!Number.isFinite(numericId) || numericId <= 0) return null;
  if (targets.some((t) => t.kind === "chatbot" && Number(t.id) === numericId)) {
    return { chatbotId: numericId };
  }
  return { userId: numericId };
}
